"use client";

import type { VideoContainer } from "mediatools";
import { useTranslations } from "next-intl";
import { OptionRadioGroup } from "../_components/OptionRadioGroup";
import { VideoFormatRadio } from "./forms";
import type { MediaOperation, OperationOptionsProps } from "./types";
import { runVideoConversion } from "./video";

interface RotateVideoOpts {
  format: VideoContainer;
  rotate: "90" | "180" | "270";
}

function RotateVideoForm({
  options,
  setOptions,
  disabled,
}: OperationOptionsProps<RotateVideoOpts>) {
  const t = useTranslations("mediaTools.options.rotateVideo");
  const angles = [
    { value: "90" as const, label: t("angles.90") },
    { value: "180" as const, label: t("angles.180") },
    { value: "270" as const, label: t("angles.270") },
  ];

  return (
    <div className="grid gap-6 sm:grid-cols-2">
      <OptionRadioGroup
        name="angle"
        label={t("rotationLabel")}
        value={options.rotate}
        onChange={(rotate) => setOptions({ ...options, rotate })}
        options={angles}
        disabled={disabled}
      />
      <VideoFormatRadio
        value={options.format}
        onChange={(format) => setOptions({ ...options, format })}
        disabled={disabled}
        label={t("formatLabel")}
      />
    </div>
  );
}

export const rotateVideoOperation: MediaOperation<RotateVideoOpts> = {
  id: "rotate-video",
  group: "video",
  inputKinds: ["video"],
  outputKind: "video",
  showSourcePreview: true,
  defaultOptions: { format: "mp4", rotate: "90" },
  OptionsForm: RotateVideoForm,
  run: (ctx, options) =>
    runVideoConversion(
      ctx,
      { format: options.format, rotate: Number(options.rotate) as 90 | 180 | 270 },
      "rotated"
    ),
};
